import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export type CustomTranslationFnc = (key: string) => string;
export type CustomTranslationHook = () => {
  t: CustomTranslationFnc;
};

const useCustomTranslation: CustomTranslationHook = () => {
  const { t } = useTranslation();

  const translateFnc: CustomTranslationFnc = useCallback(
    (key: string) => {
      return t(key) || key;
    },
    [t],
  );

  return { t: translateFnc };
};

export default useCustomTranslation;
